export default {
    url: '/form/:id',
    abstract: true,
    template: `
    <div class="col00">
        <div class="heading01 type01">
            <ul class="actions01">
                <li><a ui-sref="authorized.forms.forms.list()" class="btn discrete" >{{ 'general.Back to list' | translate }}</a></li>
            </ul>
            <h1>{{ vm.formModel.activeI18n.name }} <span class="tag color01" ng-if="vm.formModel.hasAssessmentQuestions">{{ 'forms.Needs assessment' | translate }}</span></h1>
        </div>
        <ul class="metablock">
            <li>
                <div class="label">{{ 'forms.Author' | translate }}</div>
                <div class="value">{{ vm.formModel.author.displayName }}</div>
            </li>
            <li class="type01">
                <div class="label">{{ 'forms.Date created' | translate }}</div>
                <div class="value">{{ vm.formModel.createdAt * 1000 | date : 'dd.MM.yyyy' }}</div>
            </li>
        </ul>
        <ul class="tabs01">
            <li>
                <a ui-sref="authorized.forms.forms.form.general"
                 ng-class="{ active: vm.$state.includes('authorized.forms.forms.form.general') || vm.$state.current.name === 'authorized.forms.forms.form' }">
                    {{ 'General' | translate }}
                </a>
            </li>
            <li>
                <a ui-sref="authorized.forms.forms.form.questions" ng-class="{ active: vm.$state.includes('authorized.forms.forms.form.questions') }">
                    {{ 'Questions' | translate }}
                </a>
            </li>
            <li class="f-right">
                <forms-forms-translation ng-if="vm.QuestionService.canManageQuestionRelatedData()" form="vm.form" form-model="vm.formModel"></forms-forms-translation>
            </li>
        </ul>
        <ui-view></ui-view>
        <ul class="actions01">
            <li><a ui-sref="authorized.forms.forms.list()" class="btn discrete" >{{ 'general.Back to list' | translate }}</a></li>
        </ul>
    </div>
    `,
    resolve: {
        formModel (FormResource, $stateParams) {
            return FormResource.get({ id: $stateParams.id, expand: 'formI18ns,category,author,tags,activeI18n,sites' }).$promise;
        }
    },
    controller ($state, formModel, FormFactory, FormResource, FormService, QuestionService) {
        this.$state = $state;
        this.formModel = formModel;
        this.FormService = FormService;
        this.QuestionService = QuestionService;
        this.form = FormFactory.create(new FormResource, model => model.$update({ id: model.id, expand: 'formI18ns,category,author,tags,activeI18n' }));

        this.form.model = angular.copy(this.formModel);
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/forms/form/index.js